/** @file Keys of the selected event in the open animation: add one at the playhead, delete one per row. */
import { Button } from '../../ui-kit/Button';
import type { RigView } from '../rigKit/rigView';

/** Props of EventKeys; `event` is the selected event's id. */
export interface EventKeysProps {
  view: RigView;
  event: string;
}

/** Only while editing keys (Animate mode with an open animation); otherwise one hint line. */
export function EventKeys({ view, event }: EventKeysProps) {
  const { doc, t, run, target } = view;
  if (target.kind !== 'key') return <p className="rig-hint">{t('panels.rig.keyHint')}</p>;
  const { animation, frame } = target;
  const keys = (doc.animations[animation]?.events ?? []).filter((k) => k.event === event);
  const remove = (f: number): void => { run([{ name: 'animation.deleteKeys', input: { animation, channel: 'event', target: event, frames: [f] } }]); };
  return (
    <div className="rig-body">
      <Button label={t('panels.events.keyAt', { frame })} disabled={keys.some((k) => k.f === frame)} onClick={() => { run([{ name: 'animation.setEventKey', input: { animation, frame, event } }]); }} />
      <ul aria-label={t('panels.events.keys')}>
        {keys.map((k) => (
          <li key={k.f} className="rig-row">
            {t('panels.events.keyRow', { frame: k.f })}
            <Button label={t('panels.rig.delete')} danger onClick={() => { remove(k.f); }} />
          </li>
        ))}
      </ul>
    </div>
  );
}
